import { IconPaths, KTSVG } from '../../../helpers'
import { ThemeModeType, useThemeMode, systemMode } from './ThemeModeProvider'
import { Dropdown, DropdownItem } from '../../../../app/components'

/* eslint-disable jsx-a11y/anchor-is-valid */

export const ThemeModeSwitcher = () => {
  const { mode, menuMode, updateMode, updateMenuMode } = useThemeMode()
  const calculatedMode = mode === 'system' ? systemMode : mode
  const switchMode = (_mode: ThemeModeType) => {
    updateMenuMode(_mode)
    updateMode(_mode)
  }

  return (
    <Dropdown
      variant='transparent'
      icon={calculatedMode === 'dark' ? IconPaths.Moon : IconPaths.Sun}
    >
      <DropdownItem onClick={() => switchMode('light')} active={menuMode === 'light'}>
        <div className='d-flex align-items-center'>
          <KTSVG path={IconPaths.Sun} className='svg-icon-3 me-3' />
          <span>Padrão</span>
        </div>
      </DropdownItem>
      <DropdownItem onClick={() => switchMode('dark')} active={menuMode === 'dark'}>
        <div className='d-flex align-items-center'>
          <KTSVG path={IconPaths.Moon} className='svg-icon-3 me-3' />
          <span>Dark</span>
        </div>
      </DropdownItem>
      <DropdownItem onClick={() => switchMode('system')} active={menuMode === 'system'}>
        <div className='d-flex align-items-center'>
          <KTSVG path={IconPaths.System} className='svg-icon-3 me-3' />
          <span>Sistema</span>
        </div>
      </DropdownItem>
    </Dropdown>
  )
}
